import { render, staticRenderFns } from "./Stap3.vue?vue&type=template&id=bbaf945e&"
import script from "./Stap3.vue?vue&type=script&lang=js&"
export * from "./Stap3.vue?vue&type=script&lang=js&"
import style0 from "./Stap3.vue?vue&type=style&index=0&id=bbaf945e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports